import clsx from "clsx";
import { hueFor, initialsFor } from "../utils";
import s from "./Avatar.module.css";

export interface AvatarProps {
  name: string;
  email?: string;
  src?: string;
  size?: 24 | 32 | 40;
  className?: string;
  /** Adds a status dot. The dot is decorative: say the status in the accessible name of the row that holds it. */
  presence?: "online" | "away" | "offline";
}

export function Avatar({ name, email, src, size = 32, className, presence }: AvatarProps) {
  const hue = hueFor((email ?? name).toLowerCase());
  if (presence) {
    return (
      <span className={clsx(s.wrap, className)} aria-hidden>
        <Avatar name={name} email={email} src={src} size={size} />
        <span className={clsx(s.dot, s[presence])} style={{ width: Math.max(8, size * 0.3), height: Math.max(8, size * 0.3) }} />
      </span>
    );
  }
  return (
    <span
      className={clsx(s.avatar, className)}
      style={{ width: size, height: size, fontSize: size * 0.4, ["--hue" as string]: `var(--label-${hue})` }}
      aria-hidden
    >
      {src ? <img src={src} alt="" width={size} height={size} /> : initialsFor(name)}
    </span>
  );
}
